import React from 'react'

const Thankyou = () => {
  return (
    <div>Thankyou</div>
  )
}

export default Thankyou